/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import css from './StaticBannerCarousel.APP_TARGET.scss';
import Slider from 'react-slick';
import classNames from 'classnames';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import { WEBP_PNG_TYPE } from 'Constants/images';
import { IMAGE_PLACEHOLDER } from 'Constants/imageUrls';

const StaticBannerCarousel = ({ items, 'data-aut-id': autId }) => {
    const slider = useRef(null);
    const [activeIndexSlider, setActiveIndexSlider] = useState(0);
    const [imageDisplayUrls, setImageDisplayUrls] = useState(() =>
        items.map(item => ({
            originalFileName: item.key_image || '',
            displayFileName: item.key_image || '',
            hasErrored: false // flag if failed get image from server
        }))
    );
    const sliderSettings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        afterChange: index => setActiveIndexSlider(index),
        dotsClass: css['slick-dots'],
        className: css['slick-slide'],
        lazyLoad: 'progressive'
    };

    function handleDotClick(idx) {
        slider.current.slickGoTo(idx);
        setActiveIndexSlider(idx);
    }

    useEffect(() => {
        setImageDisplayUrls(items.map(item => ({
            originalFileName: item.key_image || '',
            displayFileName: item.key_image || '',
            hasErrored: false
        })));
    }, [items]);

    const handleImageError = index => {
        setImageDisplayUrls(prevUrls => {
            const newUrls = [...prevUrls];

            if (newUrls[index] && !newUrls[index].hasErrored) {
                // logic for if failed get image from server
                newUrls[index].hasErrored = true;
                newUrls[index].displayFileName = IMAGE_PLACEHOLDER;
            }
            return newUrls;
        });
    };

    return (
        <div data-aut-id={ autId } className={ css['carousel-container'] }>
            <Slider { ...sliderSettings } initialSlide={ 0 } ref={ slider } lazyLoad="progressive">
                {imageDisplayUrls?.map((imageData, index) => (
                    <a
                        href={ items[index]?.deep_link }
                        rel="noreferrer"
                        key={ index }
                        className={ css['carousel-slide'] }
                        style={ { cursor: 'pointer' } }
                    >
                        <ImageWrapper
                            data-aut-id="bannerBooking"
                            fileName={ imageData.displayFileName }
                            types={ WEBP_PNG_TYPE }
                            supportForDifferentSize
                            alt={ `Slide ${index}` }
                            onError={ () => handleImageError(index) }
                        />
                    </a>
                ))}
            </Slider>
            {items && items.length > 1 && <div
                className={ css.dotContainer }
            >
                <div className={ css.dotSection }>
                    {items.map((_, idx) => (
                        <div
                            data-aut-id={ `carousel-slide-${idx}` }
                            key={ idx }
                            className={ classNames(css.dotItem, { [css.dotItemActive]: idx === activeIndexSlider }) }
                            onClick={ () => handleDotClick(idx) }
                        />))}
                </div>
            </div>}
        </div>
    );
};

StaticBannerCarousel.propTypes = {
    items: PropTypes.array,
    'data-aut-id': PropTypes.string
};

StaticBannerCarousel.defaultProps = {
    className: ''
};

export default StaticBannerCarousel;
